import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@/types/general';
export const Twitter = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_8_4758)"><path d="M9.92637 7.70109L16.1356 0.502808H14.6643L9.27283 6.75307L4.96666 0.502808H0L6.51172 9.95423L0 17.5028H1.47153L7.16513 10.9024L11.7127 17.5028H16.6794L9.92624 7.70109H9.92665H9.92637ZM7.91097 10.0374L7.25116 9.09631L2.00165 1.60747H4.26169L8.49821 7.65119L9.15802 8.59228L14.6649 16.4482H12.4049L7.9111 10.0377V10.0373L7.91097 10.0374Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_8_4758"><rect width="16.6792" height="17" fill="white" transform="translate(0 0.502808)" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="currentColor" className={props.className}>{t0}{t1}</svg>;
    $[2] = props.className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};